import { COUNTRIES } from '../../components/InputPhone/lib/constants';
import type { WidgetLocale } from '../../types/widgetLocale';

import { getLangLocale } from '../getIntlLocale';

export function getCountryDisplayName(regionCode: string, locale: WidgetLocale): string {
  const intlLocale = getLangLocale(locale);
  let resolved: string | undefined;
  try {
    const display = new Intl.DisplayNames([intlLocale], { type: 'region' }).of(regionCode);
    if (display) {
      resolved = display;
    }
  } catch {
    resolved = undefined;
  }
  if (resolved) {
    return resolved;
  }
  return COUNTRIES.find((c) => c.code === regionCode)?.name ?? regionCode;
}
